// SPEC 28 / P37-1 — canned responses indexadas por (support_origin, question_type)
export const SUPPORT_TEMPLATES = {
  tenant_prospect: {
    about_this_listing: {
      id: 'tp-listing',
      group: 'TP',
      title: 'Dúvida sobre anúncio',
      body: 'Olá! Sou do suporte do plantão. Vou conferir os dados do anúncio e te retorno com o ajuste correto. Se puder, me envie o código do imóvel e o ponto que precisa revisar.',
    },
    schedule_visits: {
      id: 'tp-visit',
      group: 'TP',
      title: 'Dúvida sobre visita',
      body: 'Olá! Vou te ajudar com a visita. Me confirme o cliente, o imóvel e o horário desejado para eu verificar disponibilidade e próximos passos.',
    },
    offer: {
      id: 'tp-offer',
      group: 'TP',
      title: 'Dúvida sobre proposta/valores',
      body: 'Olá! Vou te apoiar na proposta. Me confirme o imóvel e o valor pretendido para eu revisar condições, prazos e próximos passos.',
    },
    similar_listings: {
      id: 'tp-similar',
      group: 'TP',
      title: 'Imóveis similares',
      body: 'Olá! Posso te enviar opções parecidas com esse imóvel. Me confirme bairro, faixa de preço e número de quartos que procura.',
    },
    company: {
      id: 'tp-company',
      group: 'TP',
      title: 'Como funciona a Imudei',
      body: 'Olá! Eu explico como funciona o atendimento da Imudei: agendamento de visitas, proposta e acompanhamento até o fechamento. Qual parte quer entender melhor?',
    },
    fallback: {
      id: 'tp-generic',
      group: 'TP',
      title: 'Atendimento (TP)',
      body: 'Olá! Sou do suporte do plantão da Imudei e vou te ajudar com a sua dúvida agora mesmo.',
    },
  },
  customer_experience: {
    fallback: {
      id: 'cx-intro',
      group: 'CX',
      title: 'Apresentação ao novo cliente',
      body: 'Olá! Eu sou o corretor responsável pelo seu atendimento na Imudei. Vou acompanhar seu interesse, tirar dúvidas e organizar os próximos passos por aqui.',
    },
  },
};

export const QUESTION_TYPE_LABELS = {
  about_this_listing: 'Sobre o anúncio',
  offer: 'Proposta/valores',
  similar_listings: 'Imóveis similares',
  schedule_visits: 'Agendamento de visita',
  company: 'Sobre a Imudei',
};

export const SUPPORT_ORIGIN_LABELS = {
  tenant_prospect: 'TP',
  customer_experience: 'CX',
};

// Lista achatada usada na biblioteca de respostas (painel "Suporte TP/CX").
export const supportTemplates = Object.values(SUPPORT_TEMPLATES).flatMap(
  byType => Object.values(byType)
);

export const resolveSupportTemplate = conversation => {
  const origin = conversation?.duty?.support_origin || 'customer_experience';
  const type = conversation?.duty?.question_type;
  const byType =
    SUPPORT_TEMPLATES[origin] || SUPPORT_TEMPLATES.customer_experience;
  return byType[type] || byType.fallback;
};

export const pluralizeVisits = count =>
  count === 1 ? '1 visita agendada' : `${count} visitas agendadas`;

// Intro CX ciente das visitas de amanhã do contato (SPEC 28 §7.3).
export const buildCxIntro = conversation => {
  const base = SUPPORT_TEMPLATES.customer_experience.fallback.body;
  const visits = conversation?.contact?.tomorrow_visits || [];
  if (!visits.length) return base;

  const lines = visits
    .map(
      visit => `• ${visit.time}${visit.address ? ` na ${visit.address}` : ''}`
    )
    .join('\n');
  return `${base}\n\nVerifiquei que você já possui ${pluralizeVisits(
    visits.length
  )} para amanhã:\n${lines}\n\nPodemos confirmar a presença?`;
};

export const resolveSupportBody = conversation => {
  const template = resolveSupportTemplate(conversation);
  if (template.id === 'cx-intro') return buildCxIntro(conversation);
  return template.body;
};

export const dutyRegionLabel = conversation =>
  conversation?.duty?.region?.label || '';

export const dutySupportQuestionLabel = conversation => {
  const supportQuestion = conversation?.duty?.support_question;
  if (!supportQuestion?.question && !supportQuestion?.answer) return '';

  return [supportQuestion.question, supportQuestion.answer]
    .filter(Boolean)
    .join(': ');
};
